import './Collaboration.css';
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next';

// Regjistro ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

function Collaboration() {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const stepsRef = useRef([]);
  const arrowsRef = useRef([]);
  
  const steps = [
    { label: t('collab.step1') },
    { label: t('collab.step2') },
    { label: t('collab.step3') },
    { label: t('collab.step4') },
    { label: t('collab.step5') },
    { label: t('collab.step6') },
    { label: t('collab.step7') },
  ];

  useEffect(() => {
    const steps = stepsRef.current;
    const arrows = arrowsRef.current;
    
    // Vendos gjendjen fillestare të fshehur
    gsap.set(steps, {
      opacity: 0,
      y: 30,
      scale: 0.9
    });
    
    gsap.set(arrows, {
      opacity: 0,
      scaleY: 0
    });

    // Krijo timeline për animacionet
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: 1,
        toggleActions: "play none none reverse"
      }
    });

    // Shto animacionet për secilin hap dhe shigjetën
    steps.forEach((step, index) => {
      // Animo hapin
      tl.to(step, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        ease: "back.out(1.7)"
      }, index * 0.3);

      // Animo shigjetën (nëse ekziston)
      if (arrows[index]) {
        tl.to(arrows[index], {
          opacity: 1,
          scaleY: 1,
          duration: 0.4,
          ease: "power2.out"
        }, index * 0.3 + 0.2);
      }
    });

    // Pastro animacionet kur komponenti çmontohet
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [t]);

  return (
    <section className="collab-section" id="collaboration" ref={sectionRef}>
      <div className="collab-title">
        {t('collab.title')}
      </div>
      <div className="collab-flow">
        {steps.map((step, i) => (
          <div className="collab-step-wrap" key={i}>
            <div 
              className="collab-step-box"
              ref={el => stepsRef.current[i] = el}
            >
              {step.label}
            </div>
            {i < steps.length - 1 && (
              <div 
                className="collab-arrow-css"
                ref={el => arrowsRef.current[i] = el}
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Collaboration; 